<template>
	<v-dialog
		persistent
		max-width="600"
		v-model="dialog"
	>
		<v-card v-if="e">
			<v-card-title>
				<span>{{e.title}}:</span>
			</v-card-title>
			<v-card-text>
				<template v-if="rich">
					<TextEditor
						v-bind:content="{value: value}"
						ref="richEditor"
					/>
				</template>
				<template v-else>
					<v-textarea
						hide-details
						v-model="value"
						filled
						class="body-2"
						:height="90"
						no-resize
					></v-textarea>
				</template>
			</v-card-text>
			<v-card-actions class="mx-4 pb-5">
				<v-btn
					color="blue darken-1"
					text
					v-on:click="save"
					outlined
					small
					:loading="saveInAction"
				>
					Išsaugoti
				</v-btn>
				<v-btn
					color="blue darken-1"
					text
					v-on:click="closeDialog"
					outlined
					small
					:disabled="saveInAction"
				>
					Atšaukti
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import TextEditor from "../TextEditor";
	import AtlasHelper from "../helpers/AtlasHelper";

	export default {
		data: function(){
			var data = {
				dialog: false,
				saveInAction: false,
				e: null,
				value: null,
				rich: false
			};
			return data;
		},
		components: {
			TextEditor
		},
		created: function(){
			this.$vBus.$on("show-attribute-edit-form", this.showForm);
		},
		beforeDestroy: function(){
			this.$vBus.$off("show-attribute-edit-form", this.showForm);
		},
		methods: {
			closeDialog: function(){
				this.dialog = false;
			},
			showForm: function(e){
				this.e = e;
				this.value = e.value;
				this.rich = e.rich;
				this.dialog = true;
			},
			save: function(){
				this.saveInAction = true;
				var newValue;
				if (this.$refs.richEditor) {
					newValue = this.$refs.richEditor.newValue;
				} else {
					newValue = this.value;
				}
				var params = {};
				params[this.e.key] = newValue;
				AtlasHelper.createOrUpdateAtlas(params, this.e.atlasId).then(function(response){
					this.saveInAction = false;
					this.dialog = false;
					if (this.e.callback) {
						this.e.callback(response);
					}
				}.bind(this), function(){
					this.$vBus.$emit("show-message", "error");
					this.saveInAction = false;
				}.bind(this));
			}
		}
	}
</script>